import { Popup } from 'devextreme-react';
import React from 'react'

const UniqueCourts = ({visible, onClose}) => {
return (
    // <>
    <Popup
      visible={visible}
      onHiding={onClose}
      showTitle={false}
      width={520}
      height="auto"
      showCloseButton
      hideOnOutsideClick={false}
    >
      {/* Header */}
      <div style={{ background: '#2B2A7D', color: '#fff', padding: '14px 16px', borderTopLeftRadius: 6, borderTopRightRadius: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2a10 10 0 100 20 10 10 0 000-20Zm4 11h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3V8a1 1 0 112 0v3h3a1 1 0 110 2Z" fill="#fff"/>
            </svg> */}
            {/* <p style={{ margin: 0, fontWeight: 600 }}>{title}</p> */}
          </div>
        </div>
      </div>
      <div style={{ padding: 20, background: '#fff' }}>
        <p style={{ margin: '12px 0 24px', fontSize: 16, color: '#333' }}>
          Dockets must be in the same courts
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button
            className="btn primary_btn"
            onClick={onClose}
            style={{
              background: '#2B2A7D',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              cursor: 'pointer'
            }}
          >
            Save
          </button>
        </div>
      </div>
    </Popup>
    // </>
  );
}

export default UniqueCourts
